<body>
  <header class="flex justify-center items-center">
    <img src="cb-logo.svg" />
  </header>
  <main class="loan-page">
    <h1>Reset Password</h1>
    <div class="loan-section max-w-500 w-full">
      <p class="m-0">Enter the email associated with your account and we will send you a link to reset your password.</p>
      <app-loan-input label="Email" [control]="emailControl" />
      @if (message) {
        <p class="pt-10">{{ message }}</p>
      }
      @if (error) {
        <p class="pt-10 text-err">{{ error }}</p>
      }
      <div class="flex justify-between items-center pt-10">
        <app-button [onClick]="onResetPasswordClick">Reset Password</app-button>
      </div>
    </div>
  </main>
</body>
